// list-groups.component.ts
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NzTreeNodeOptions } from 'ng-zorro-antd/core/tree';
import { GruposService, Grupo as GrupoApi } from 'src/app/core/services/grupos.service'; // 👈 usa el servicio


// Lo que espera el componente internamente
interface Grupo {
  id: number;
  nombre: string;
  padre_id: number | null;
  orden: number;
}

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss']
})
export class GroupsComponent implements OnInit {



  grupos: Grupo[] = [];
  byId = new Map<number, Grupo>();
  idxHijos = new Map<number | null, number[]>();

  treeNodes: NzTreeNodeOptions[] = [];
  seleccion: number | null = null;
  filtrados: Grupo[] = [];

  @Output() idGroup = new EventEmitter<number>();
  @Input() tipoGrupo: string = '';

  constructor(private gruposService: GruposService) {
    
  }

  ngOnInit(): void {
    // si quieres solo raíces usa this.load(true)
    this.load(false); // false = todos; true = solo raíces
  }


  load(onlyRoots: boolean) {
    const src$ = onlyRoots
      ? this.gruposService.getRoots() // GET /grupos?roots=true
      : this.gruposService.getAll(true, this.tipoGrupo);  // GET /grupos

    src$.subscribe({
      next: (data: GrupoApi[]) => {
        this.grupos = this.normalizar(data);
        this.rebuildIndices();
        this.refreshTree();
      },
      error: (err) => {
        console.error('Error cargando grupos', err);
      }
    });
  }

  /** Convierte API { padre } → interno { padre_id } */
  private normalizar(data: GrupoApi[]): Grupo[] {
    return (data ?? []).map(r => ({
      id: r.id,
      nombre: r.nombre,
      padre_id: r.padre ? r.padre.id : null,
      orden: r.orden ?? 0
    }));
  }

  rebuildIndices(): void {
    this.byId.clear();
    this.idxHijos.clear();

    for (const g of this.grupos) {
      this.byId.set(g.id, g);
      const k = g.padre_id ?? null;
      if (!this.idxHijos.has(k)) this.idxHijos.set(k, []);
      this.idxHijos.get(k)!.push(g.id);
    }

    // ordena hijos por 'orden'
    for (const [k, lista] of this.idxHijos.entries()) {
      lista.sort((a, b) => (this.byId.get(a)!.orden ?? 0) - (this.byId.get(b)!.orden ?? 0));
      this.idxHijos.set(k, lista);
    }
  }

  refreshTree(): void {
    const map = new Map<number, NzTreeNodeOptions & { _orden?: number }>();
    const roots: (NzTreeNodeOptions & { _orden?: number })[] = [];

    for (const g of this.grupos) {
      map.set(g.id, {
        title: g.nombre,
        key: String(g.id),
        value: g.id,
        selectable: true,
        children: [],
        _orden: g.orden
      });
    }

    for (const g of this.grupos) {
      const node = map.get(g.id)!;
      if (g.padre_id == null) {
        roots.push(node);
      } else {
        const p = map.get(g.padre_id);
        if (p) {
          (p.children ||= []).push(node);
        } else {
          roots.push(node);
        }
      }
    }

    const sortRec = (nodes: (NzTreeNodeOptions & { _orden?: number })[]) => {
      nodes.sort((a, b) => (a._orden ?? 0) - (b._orden ?? 0));
      for (const n of nodes) {
        if (n.children && n.children.length) sortRec(n.children as any);
      }
    };
    sortRec(roots);

    this.treeNodes = roots;
  }

  private collectDescendants(rootId: number): Set<number> {
    const keep = new Set<number>();
    const q = [rootId];
    while (q.length) {
      const cur = q.shift()!;
      if (keep.has(cur)) continue;
      keep.add(cur);
      for (const h of this.idxHijos.get(cur) ?? []) q.push(h);
    }
    return keep;
  }

  async onPick(event: any) {
    this.idGroup.emit(event);
  }


  padreNombre(g: Grupo): string {
    if (g.padre_id == null) return '—';
    return this.byId.get(g.padre_id)?.nombre ?? '—';
  }
}
